<!-- 新增卡类型接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "carports": "1",
                "chargeGroupCode": "0",
                "code": "CZC0001TEST01",
                "expAlertValue": "10",
                "fullLimitValue": "100",
                "isCustomCharge": "0",
                "isDatePri": "0",
                "isDynamic": "0",
                "isFullLimit": "0",
                "isTimePri": "0",
                "name": "月卡TEST",
                "parkCode": "2KM43Y461",
                "settlePrice": "100",
                "settleType": "0",
                "vipGroupType": "0"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台新增卡类型",
                t_url: this.commonUrls.test + "addCusVipType",
                p_url: this.commonUrls.prod + "addCusVipType",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'code', info2: '是', info3: 'String', info4: 'VIP类型唯一编号' },
                        { info1: 'name', info2: '是', info3: 'String', info4: 'VIP类型名称' },
                        { info1: 'settleType', info2: '是', info3: 'Integer', info4: '结算类型 0时间结算，1余额结算，2次数结算' },
                        { info1: 'settlePrice', info2: '是', info3: 'Decimal', info4: '结算单价 时间结算，2位小数，表示元/月；余额结算，2位小数，表示充值比例如1.2；次数结算，表示元/次' },
                        { info1: 'isDynamic', info2: '是', info3: 'Integer', info4: '是否多位多车 0否，1是' },
                        { info1: 'carports', info2: '是', info3: 'Integer', info4: '可用车位数，正整数，默认1，表示这种VIP类型可用车位数，开通VIP票时，对应VIP票可用车位数=VIP类型可用车位数 * 开通张数' },
                        { info1: 'isDatePri', info2: '是', info3: 'Integer', info4: '是否区分日期，0否，1是，如果VIP类型全部日期都有效，填否；如果指定日期有效，填是。并指定有效日期段' },
                        { info1: 'isTimePri', info2: '是', info3: 'Integer', info4: '是否区分时间 0否，1是' },
                        { info1: 'isCustomCharge', info2: '是', info3: 'Integer', info4: '是否自定义计费 0否，1是' },
                        { info1: 'chargeGroupCode', info2: '是', info3: 'String', info4: '计费组编码，可通过查询计费规则获取' },
                        { info1: 'vipGroupType', info2: '是', info3: 'Integer', info4: 'VIP组类型 0普通vip（包括时间、储值、计次），1访客vip，2黑名单vip，3预定vip，4共享vip' },
                        { info1: 'isFullLimit', info2: '是', info3: 'Integer', info4: '是否开启满位控制 0否，1是' },
                        { info1: 'fullLimitValue', info2: '是', info3: 'Integer', info4: '最多允许车辆数' },
                        { info1: 'expAlertValue', info2: '是', info3: 'Integer', info4: 'VIP临过期提示天数阈值，小于等于此阈值将提示。暂只支持默认提示' },
                        { info1: 'priDateArr', info2: '否', info3: 'JSONArray', info4: '有效日期，isDatePri为1，此项必填' },
                        { info1: 'priTimeArr', info2: '否', info3: 'JSONArray', info4: '有效时间段，isDatePri为1，此项必填' },
                        { info1: 'priChannelArr', info2: '否', info3: 'JSONArray', info4: '通行权限数组，需要停车场管理系统提供通道编号，为空表示有所有权限' }
                    ]
                }, {
                    titleName: 'priDateArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startDate', info2: '是', info3: 'String', info4: '' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '' }
                    ]
                }, {
                    titleName: 'priTimeArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时刻，HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时刻，HH:mm:ss' }
                    ]
                }, {
                    titleName: 'priChannelArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'channelCode', info2: '否', info3: 'String', info4: '通道编号' },
                        { info1: 'priType', info2: '否', info3: 'String', info4: '权限类别，0无此通道权限并播报，1有此通道权限，2无此通道权限但不播报' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/vip/addCusVipType.vue